export const socialsData = {
    github: 'https://github.com/ElrondBuds',
    facebook: 'https://www.facebook.com/',
    twitter: 'https://twitter.com/eBudsNFT',
    medium: 'https://medium.com/@ebuds',
    youtube: 'https://www.youtube.com/channel/UCuvu3CHRL-1fP4wAhzeAZxg'
}